import state from './state'
import actions from './actions'
import getters from './getters'
import mutations from './mutations'

const namespaced = true

export default {
	state,
	actions,
	getters,
	mutations,
	namespaced,
}
